import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { monthlyReportsRepo } from '../repo/monthlyReportsRepo'

export function useMonthlyReports() {
  return useQuery({
    queryKey: ['monthly-reports'],
    queryFn: () => monthlyReportsRepo.findAll(),
  })
}

export function useMonthlyReport(id: string | undefined) {
  return useQuery({
    queryKey: ['monthly-reports', id],
    queryFn: () => monthlyReportsRepo.findById(id!),
    enabled: !!id,
  })
}

export function useClientMonthlyReports(clientId: string | undefined) {
  return useQuery({
    queryKey: ['monthly-reports', 'client', clientId],
    queryFn: () => monthlyReportsRepo.findByClient(clientId!),
    enabled: !!clientId,
  })
}

export function useMonthlyReportsByMonth(year: number, month: number) {
  return useQuery({
    queryKey: ['monthly-reports', 'month', year, month],
    queryFn: () => monthlyReportsRepo.findByMonth(year, month),
  })
}

export function useCreateMonthlyReport() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: any) => monthlyReportsRepo.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['monthly-reports'] })
    },
  })
}

export function useUpdateMonthlyReport() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, updates }: { id: string; updates: any }) =>
      monthlyReportsRepo.update(id, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['monthly-reports'] })
    },
  })
}

export function useDeleteMonthlyReport() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => monthlyReportsRepo.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['monthly-reports'] })
    },
  })
}
